<template>
	<div :class="tagClasses">
		<animated-number
			:prev-number="displayChange"
			:number="displayChange"
			:srv-numeral-format="numeralFormat"
		></animated-number>
		{{ contingentPercSign }}
		<span :class="arrowGlyphicon"></span>
	</div>
</template>

<script>
import AnimatedNumber from "../properties_components/animated_number.vue";
import { i18n, percentageChange } from "../utils";

export default {
	mixins: [i18n],
	props: {
		// Plain numbers
		srvFromNumber: Number,
		srvFoNumber: Number,
		// Data to load ActorProperties
		fromPropTypeKey: Number,
		fromActorId: Number,
		fromPhaseId: Number,
		toPropTypeKey: Number,
		toActorId: Number,
		toPhaseId: Number,
		appValueColumn: {
			type: String,
			default: "current_value",
		},
		showAbsoluteChange: {
			type: Boolean,
			default: false,
		},
		srvNegativeChangeDesired: {
			type: Boolean,
			default: false,
		},
		numeralFormat: {
			type: String,
			default: "0,0.0",
		},
		extraClasses: String,
	},
	data: function () {
		return {
			locale: I18n.locale,
		};
	},
	components: {
		"animated-number": AnimatedNumber,
	},
	computed: {
		fromActorProperty: function () {
			return this.fromPropTypeKey && this.fromActorId
				? VueStore.getters.actorPropertyOfTypeFor(
						this.fromActorId,
						this.fromPropTypeKey,
					)
				: null;
		},
		toActorProperty: function () {
			return this.toPropTypeKey && this.toActorId
				? VueStore.getters.actorPropertyOfTypeFor(
						this.toActorId,
						this.toPropTypeKey,
					)
				: null;
		},
		fromNumber: function () {
			return this.fromActorProperty
				? this.fromActorProperty.values[this.fromPhaseId][this.appValueColumn]
				: this.srvFromNumber;
		},
		toNumber: function () {
			return this.toActorProperty
				? this.toActorProperty.values[this.toPhaseId][this.appValueColumn]
				: this.srvToNumber;
		},
		percentagChangeInternal: function () {
			return percentageChange(this.fromNumber, this.toNumber);
		},
		displayChange: function () {
			if (this.showAbsoluteChange) {
				return this.toNumber - this.fromNumber;
			} else {
				return this.percentagChangeInternal === Infinity
					? "∞"
					: this.percentagChangeInternal === -Infinity
						? "-∞"
						: `${this.percentagChangeInternal}%`;
			}
		},
		contingentPercSign: function () {
			return this.showAbsoluteChange ||
				this.percentagChangeInternal === Infinity ||
				this.percentagChangeInternal === -Infinity
				? ""
				: "%";
		},
		negativeChangeDesired: function () {
			return (
				this.srvNegativeChangeDesired ||
				(this.fromActorProperty
					? this.fromActorProperty.property.is_desirable
					: null) ||
				(this.toActorProperty
					? this.toActorProperty.property.is_desirable
					: null)
			);
		},
		tagClasses: function () {
			const classes = ["Tag"];
			// @ts-expect-error
			classes.push(this.extraClasses);
			if (this.percentagChangeInternal == 0) {
				classes.push("Tag--neutral");
				// @ts-expect-error
			} else if (this.percentagChangeInternal > 0) {
				classes.push(
					this.negativeChangeDesired ? "Tag--negative" : "Tag--positive",
				);
			} else {
				classes.push(
					this.negativeChangeDesired ? "Tag--positive" : "Tag--negative",
				);
			}
			return classes.join(" ");
		},
		arrowGlyphicon: function () {
			// @ts-expect-error
			if (this.percentagChangeInternal > 0) {
				return "glyphicon glyphicon-arrow-up";
				// @ts-expect-error
			} else if (this.percentagChangeInternal < 0) {
				return "glyphicon glyphicon-arrow-down";
			}
		},
	},
	mounted() {},
	beforeDestroy() {},
	methods: {},
};
</script>
